import { Navigate, useLocation } from 'react-router-dom';
import type { ErrorLocationState } from '@/Pages/Error/types/errorLocationState';

type TenantBrandingGateProps = {
  notFound: boolean;
  children: React.ReactNode;
};

const NOT_FOUND_STATE: ErrorLocationState = { errorType: 'not_found' };

export function TenantBrandingGate({ notFound, children }: TenantBrandingGateProps) {
  const location = useLocation();

  if (notFound && location.pathname !== '/error') {
    return <Navigate to="/error" replace state={NOT_FOUND_STATE} />;
  }

  return children;
}
